/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { createRef } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Swiper from 'swiper/swiper-bundle.min.js';
import Request from '../../utils/request';
import px2rem from "../../utils/px2rem";
import utils from "../../utils/utils";
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'
import 'react-lazy-load-image-component/src/effects/opacity.css';
import "./style.less";

function componentDataFormat(props) {
  const { config = {}, createTime } = props;
  if (createTime && Number(createTime) > 1713960000000) {
    return config;
  }
  const { baseConfig = {}, grains = [] } = config;
  if (grains && grains[0] && !grains[0].cardGroup) {
    const data = {
      baseConfig: {
        moduleMarginTop: baseConfig.moduleMarginTop,
        title: baseConfig.title,
        addToNav: baseConfig.addToNav,
      },
      grains: grains.map(item => {
        const { cardBaseConfig = {}, commonCard = {}, hotCard = {} } = item;
        return {
          cardBaseConfig: {
            backgroundImage: cardBaseConfig.backgroundImage,
            buttonText: "",
            buttonColor: "#6707ff"
          },
          cardGroup: [
            {
              commonCard,
              hotCard
            }
          ]
        }
      })
    }
    return data; 
  } else {
    return config;
  }
}

class PipelineProductCollection extends React.Component {
  constructor(props) {
    super(props);
    const dataSource = componentDataFormat(props);
    const collectionList = dataSource.grains.map(grainItem => {
      grainItem.cardGroup = grainItem.cardGroup.map(groupItem => {
        if (groupItem.commonCard.sortType !== '自定义排序') {
          groupItem.commonCard.itemList = groupItem.commonCard.itemList.map(item => {
            return {
              id: item.id,
              price: '',
              title: item.useCustomName === '是' ? item.title : '',
              recommend: item.recommendType === '自定义' ? item.recommend : '',
              useCustomName: item.useCustomName,
              recommendType: item.recommendType,
              image: 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'
            }
          });
        } else {
          groupItem.commonCard.itemList = groupItem.commonCard.itemList.map(item => {
            return {
              ...item,
              price: ''
            }
          });
        }
        return groupItem;
      });
      grainItem.groupIdx = 0;
      return grainItem;
    });
    this.state = {
      collectionList: collectionList,
      currentCollectIdx: 0
    };
    this.sortTypeMap = {
      '自定义排序': 0,
      '销量': 4,
      'GMV': 6,
      '上新时间': 8,
    };
    this.isAndroid = utils.isAndroid();
    this.mySwiper = null;
    this.mySwiperRef = createRef();
    this.collectionTabRef = null;
    this.productCollectionRef = null;
    this.isLock = false;
  }

  async componentDidMount() {

    const { grains = [] } = componentDataFormat(this.props);
    const collectionList = JSON.parse(JSON.stringify(grains));

    for (let index = 0; index < collectionList.length; index++) {
      const grainItem = collectionList[index];
      for (let key = 0; key < grainItem.cardGroup.length; key++) {
        const delayInterval = setTimeout(async() => {
          const groupItem = grainItem.cardGroup[key];
          const { commonCard = {}, hotCard = {} } = groupItem;
          let hotCardList = [], commonCardList = [];
          if (hotCard.item.id) {
            const { id, title, url, image, useCustomName } = hotCard.item;
            const ids = [Number(id)];
            const itemList = [{
              id,
              title: useCustomName === '是' ? title : '',
              url,
              image,
              useCustomName
            }];
            hotCardList = await this.getProductListData(hotCard.productType, 4, hotCard.shihuoSubsidy, ids, itemList);
            if (hotCardList[0]) {
              Object.assign(collectionList[index].cardGroup[key].hotCard, {
                item: hotCardList[0]
              });
            }
          }
  
          if (commonCard.itemList.length > 0) {
            const { productType, sortType, shihuoSubsidy, itemList = [] } = commonCard;
            const ids = itemList.map((item) => {
              return isNaN(Number(item.id)) ? 0 : Number(item.id);
            });
            commonCardList = await this.getProductListData(productType, sortType, shihuoSubsidy, ids, itemList);
            Object.assign(collectionList[index].cardGroup[key].commonCard, {
              itemList: commonCardList
            })
          }

          this.setState({
            collectionList
          }, () => {
            this.initSwiper(collectionList);
          });

        }, key === 0 ? 0 : 3000);
      }
    }
  }

  initSwiper = (collectionList = []) => {
    if (collectionList.length > 1 && !this.isLock) {
      this.isLock = true;
      this.mySwiper = new Swiper(this.mySwiperRef.current, {
        autoplay: collectionList.length > 1 ? {
          disableOnInteraction: false,
          delay: 2000,
        } : false,
        loop: false,
        allowSlidePrev: true,
        allowSlideNext: true,
        slidesPerView: 'auto',
        on: {
          slideChange: (swiper) => {
            const realIndex = swiper.realIndex;
            // this.mySwiper.allowSlidePrev = !swiper.isBeginning;
            // this.mySwiper.allowSlideNext = !swiper.isEnd;
            this.mySwiper && this.mySwiper.autoplay.start();
            this.addClickEventHandlers(swiper);
            this.setState({
              currentCollectIdx: realIndex
            }, () => {
              this.updateTabPosition();
            })
          }
        }
      });
      this.mySwiperRef.current.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
    } else {
      this.addClickEventHandlers();
    }
  }

  addClickEventHandlers = (swiper) => {
    // 获取当前活动的 slide
    let activeSlide = null;
    if (swiper) {
      activeSlide = swiper.slides[swiper.activeIndex];
    } else {
      activeSlide = this.productCollectionRef.querySelector('.swiper-slide');
    }
    if (!activeSlide) {
      return;
    }
    const clickEventHandler = activeSlide.getAttribute('click-event-handler');
    if (clickEventHandler) {
      return;
    }

    const switchArea = activeSlide.querySelector('.switch');

    // 换一换
    if (switchArea) {
      const clickEventHandlers = () => {
        this.mySwiper && this.mySwiper.autoplay.stop();
        const slideIdx = swiper ? swiper.realIndex : 0;
        const collectionList = this.state.collectionList;
        if (collectionList[slideIdx].groupIdx < collectionList[slideIdx].cardGroup.length - 1) {
          collectionList[slideIdx].groupIdx = collectionList[slideIdx].groupIdx + 1;
        } else {
          collectionList[slideIdx].groupIdx = 0;
        }
        this.setState({
          collectionList
        })
      }

      switchArea.addEventListener('click', clickEventHandlers);
    }


    const hotCradArea = activeSlide.querySelector('.hot-card');

    // 爆款商品卡点击
    if (hotCradArea) {
      const clickEventHandlers = () => {
        const collectIndex = hotCradArea.getAttribute('collectindex');
        const goodsId = hotCradArea.getAttribute('goodsid');
        const styleId = hotCradArea.getAttribute('styleid');
        const title = hotCradArea.getAttribute('title');
        const url = hotCradArea.getAttribute('url');
        const options = {
          name: title,
          goods_id: goodsId,
          style_id: styleId
        };
        utils.jumpToUrl(this.props.routeParams, url, url, options, -1, this.props, false, {
          ptiId: `${this.props.templatePti}:productCollection_${collectIndex}-hotCard`,
          bizExtra: {
            model_block: '爆款商品卡'
          }
        });
      }

      hotCradArea.addEventListener('click', clickEventHandlers); 
    }

    const commonCardAreas = activeSlide.querySelectorAll('.commonCard');

    // 常规商品卡点击
    commonCardAreas.forEach((area) => {
      if (area) {
        const clickEventHandlers = () => {
          const collectIndex = area.getAttribute('collectindex');
          const goodsId = area.getAttribute('goodsid');
          const styleId = area.getAttribute('styleid');
          const title = area.getAttribute('title');
          const sort = area.getAttribute('sort');
          const url = area.getAttribute('url');
          const options = {
            sort: sort,
            name: title,
            goods_id: goodsId,
            style_id: styleId
          };
          utils.jumpToUrl(this.props.routeParams, url, url, options, -1, this.props, false, {
            ptiId: `${this.props.templatePti}:productCollection_${collectIndex}-commonCard:${sort}`,
            bizExtra: {
              model_block: '常规商品卡'
            }
          });
        }
        
        area.addEventListener('click', clickEventHandlers); 
      }
    });

    activeSlide.setAttribute('click-event-handler', true);
  }

  getProductListData = (productType = '', sortType = 4, shihuoSubsidy = '否', ids = [], itemList = []) => {
    let requestUrl = '';
    switch (productType) {
      case '商品id':
        requestUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case '配色id':
        requestUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case 'skuId':
        requestUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur';
        break;
      default:
        break;
    }
    return new Promise((resolve) => {
      Request({
        url: requestUrl,
        method: "post",
        withCredentials: true,
        data: {
          ids,
          sort_tag: this.sortTypeMap[sortType] || 0,
          filter_subsidy: shihuoSubsidy === '是' ? 1 : 0,
        },
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          let notFoundList = [];
          let list = data.List;
          if (data.NotFound && data.NotFound.length > 0) {
            notFoundList = data.NotFound;
          }
          if (data.NotShow && data.NotShow.length > 0) {
            notFoundList = data.NotShow;
          }
          if (sortType === '自定义排序') {
            list = itemList.map(product => {
              const findItem = list.find((item) => item.id == product.id);
              if (findItem && findItem.id != 0) {
                // 商品维度，商品图片和价格均要实时获取
                Object.assign(product, {
                  ...findItem,
                  image: productType !== '商品id' ? findItem.image : product.image,
                  title: product.useCustomName === '是' ? product.title : findItem.title,
                  price: product !== '商品id' ? findItem.price : product.price,
                  recommend: product.recommendType === '自定义' ? product.recommend : findItem.recommend
                })
              }
              return product;
            });
          } else {
            list = list && list.map(product => {
              const findItem = itemList.find((item) => item.id == product.id);
              if (findItem && findItem.id != 0) {
                product.useCustomName = findItem.useCustomName;
                product.recommendType = findItem.recommendType;
                product.title = findItem.useCustomName === '是' ? findItem.title : product.title;
                product.recommend = findItem.recommendType === '自定义' ? findItem.recommend : product.recommend;
                // 商品维度，商品图片和价格均要实时获取
                if (productType !== '商品id') {
                  product.image = (findItem.image && findItem.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0 ) ? findItem.image : product.image; 
                }
              }
              return product;
            });
            if (notFoundList.length > 0) {
              notFoundList.forEach(id => {
                const findItem = itemList.find((item) => item.id == id);
                if (findItem) {
                  Object.assign(findItem, {
                    title: findItem.title,
                    price: '--',
                  });
                  list.push(findItem)
                }
              })
            }
          }

          resolve(list || []);
        }
      });
    });
  }


  isTextOverflowed = (element) => {
    const divHeight = element.offsetHeight;
    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
    const lineCount = Math.round(divHeight / lineHeight);
    return lineCount > 1;
  }

  renderPriceDom = (price = 9988999) => {
    let priceDom = null, decimals = '', suffix = '';
    if (price > 9999) {
      price = parseFloat((price / 10000).toFixed(1)) + '万'
    } else {
      price = String(price)
    }
    if (price.indexOf('.') >= 0) {
      price = price.split('.');
    }
    if (Array.isArray(price)) {
      if (price[1] && price[1].indexOf('万') >= 0) {
        decimals = price[1].replace('万', '');
        suffix = '万';
      } else {
        decimals = price[1];
      }
      priceDom = (
        <p className={`price ${this.isAndroid ? 'android' : 'ios'}`}>
          <span className="symbol">¥</span>
          {price[0]}.
          <span className="decimals">{decimals}</span>
          <span className="suffix">{suffix}</span>
        </p>
      )
    } else {
      priceDom = <p className={`price ${this.isAndroid ? 'android' : 'ios'}`}><span className="symbol">¥</span>{price}</p>
    }
    return priceDom;
  }

  updateTabPosition = () => {
    const collectionTabWidth = this.collectionTabRef.offsetWidth;
    const activeTab =  this.collectionTabRef.querySelector('.active');
    if (activeTab) {
      const tabItemOffsetLeft = activeTab.offsetLeft; // 元素距离左边距离
      const checkedItemWidth = activeTab.offsetWidth;
      const move = tabItemOffsetLeft - (collectionTabWidth / 2 - checkedItemWidth / 2);
      if (this.collectionTabRef.scrollWidth > collectionTabWidth) {
        this.collectionTabRef.scroll({
          top: 0,
          left: move,
          behavior: 'smooth',
        });
      }
    }
  }

  handleTabClick = (index) => {
    this.setState({
      currentCollectIdx: index
    }, () => {
      this.mySwiper.slideTo(index);
      this.updateTabPosition();
    })
  }

  renderCollectionTab() {
    let { collectionList = [], currentCollectIdx = 0 } = this.state;
    let className = '';
    if (collectionList.length > 3) {
      className = 'fixedWidth';
    } else {
      className = 'flexWidth';
    }
    return (
      <ul className="collection-tab" ref={ref => this.collectionTabRef = ref}>
        {
          collectionList.map((item, index) => {
            return (
              <li
                className={className += index === currentCollectIdx ? ' active' : ''}
                key={`tab-${index}`}
                style={{backgroundColor: utils.hexColorToRgba(index === currentCollectIdx ? item.cardBaseConfig.buttonColor || '#6707ff' : '#ffffff', index === currentCollectIdx ? 1 : 0.25)}}
                onClick={() => this.handleTabClick(index)}
              >
                {this.tabCharacters(item.cardBaseConfig.buttonText)}
              </li>
            )
          })
        }
      </ul>
    )
  }

  render() {
    const { baseConfig } = this.props.config;
    const { collectionList = [] } = this.state;
    const renderTab = collectionList.length > 1;
    return (
      <div
        ref={ref => this.productCollectionRef = ref}
        className={`pipeline-productCollection ${renderTab ? 'large' : 'small'}`}
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
        {...this.props['customAttributes']}
      >
        { renderTab && this.renderCollectionTab() }
        <div className="product-collection swiper-container" ref={this.mySwiperRef}>
          <div className="swiper-wrapper">
            {
              collectionList.map((collectItem, collectIndex) => {
                const { cardBaseConfig = {}, cardGroup = [], groupIdx = 0 } = collectItem;
                const { commonCard = {}, hotCard = {} } = cardGroup[groupIdx];
                const backgroundImageUrl = cardBaseConfig.backgroundImage || 'https://static.shihuocdn.cn/admin/files/20240401/aaeb2145f3a26d32952a7ff09457a70b.png';
                return (
                  <div
                    key={`slide-${collectIndex}`}
                    className="swiper-slide"
                    style={{
                      backgroundImage: `url(${utils.formatImgUrl(backgroundImageUrl, this.props.webpSupport)})`,
                      backgroundSize: '100% 100%',
                      backgroundRepeat: 'no-repeat'
                    }}
                  >
                    <div className="module-left">
                      {
                        hotCard.item.id && (
                          <div
                            className={cardGroup.length > 1 ? 'hot-card has-switch' : 'hot-card no-switch'}
                            collectindex={collectIndex}
                            goodsid={hotCard.item.goods_id}
                            styleid={hotCard.item.style_id}
                            url={hotCard.item.url}
                            title={hotCard.item.title}
                            style={{backgroundColor: hotCard.backgroundColor}}
                          >
                            <div className="product-img">
                              <LazyLoadImage
                                width={px2rem('96px')}
                                height={px2rem('96px')}
                                effect="opacity"
                                src={utils.formatImgUrl(hotCard.item.image, this.props.webpSupport)}
                              />
                            </div>
                            { hotCard.label && <img src={utils.formatImgUrl(hotCard.label, this.props.webpSupport)} className="tag-img" alt="" /> }
                            <p className="product-title">{hotCard.item.title}</p>
                            <div className="product-price">
                              { hotCard.item.price && this.renderPriceDom(hotCard.item.price) }
                            </div>
                          </div>
                        )
                      }
                      {
                        cardGroup.length > 1
                          && <img src="https://static.shihuocdn.cn/admin/files/20240401/c9e2635074b971dc8618c6703d882e09.png" alt="换一换" className="switch" groupidx={groupIdx} />
                      }
                    </div>
                    <ul className="module-right">
                      {
                        commonCard.itemList.map((item, index) => {
                          return (
                            <li
                              key={`slide-${collectIndex}-commonCard-${index}`}
                              className={`commonCard commonCard-${index + 1}`}
                              collectindex={collectIndex}
                              goodsid={item.goods_id}
                              styleid={item.style_id}
                              title={item.title}
                              url={item.url}
                              sort={index}
                              style={{
                                backgroundColor: commonCard.backgroundColor
                              }}
                            >
                              <LazyLoadImage
                                width={px2rem('96px')}
                                height={px2rem('96px')}
                                effect="opacity"
                                src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                                className="product-img"
                              />
                              <p className={(commonCard.showRecommend === '是' && item.recommend) ? 'product-name line-clamp-1' : 'product-name line-clamp-2'}>{item.title}</p>
                              { commonCard.showRecommend === '是' && <p className="product-recommend">{item.recommend}</p> }
                              {/* { commonCard.showRecommend === '否' && <p className="product-benefit"></p> } */}
                              <div className="product-price">
                                {
                                  item.price && this.renderPriceDom(item.price)
                                }
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }

  tabCharacters = (str) => {
    let result = '';
    let maxLength = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charAt(i);
      if (/[\u4e00-\u9fa5]/.test(char)) {
        // 中文
        if (maxLength + 2 <= 10) {
          maxLength += 2;
          result += str[i];
        }
      } else {
        // 其他，如空格、特殊符号等
        if (maxLength + 1 <= 10) {
          maxLength += 1;
          result += str[i];
        }
      }
    }

    return result;
  }

}

PipelineProductCollection.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProductCollection };
export default PipelineProductCollection;



// WEBPACK FOOTER //
// ./components/pipeline-productCollection/index.js